import { ActPhrase, Emoji } from '../types';

type MoveData = {
  winChance: number;
  isCaptured: boolean;
  isBestMove?: boolean;
};

const PLEASED_STICKERS = [
  'emoji3.3',
  'emoji9.2',
  'emoji12.3',
  'emoji13.1',
  'emoji14.2',
  'emoji16.4',
  'emoji17.3',
  'emoji20.2',
  'emoji26.5',
];

const SAD_STICKERS = [
  'emoji3.4',
  'emoji9.3',
  'emoji12.4',
  'emoji13.3',
  'emoji14.1',
  'emoji16.5',
  'emoji17.5',
  'emoji20.5',
  'emoji26.1',
];

const THINKER_STICKERS = [
  'emoji3.2',
  'emoji9.4',
  'emoji12.1',
  'emoji13.5',
  'emoji14.5',
  'emoji16.3',
  'emoji17.1',
  'emoji20.1',
  'emoji26.2',
];

const STICKER_PACKS = ['emoji3', 'emoji9', 'emoji12', 'emoji13', 'emoji14', 'emoji16', 'emoji17', 'emoji20', 'emoji26'];
const PHRASE_PACKS = ['phrase1', 'phrase2', 'phrase3', 'phrase4'];

const AVAILABLE_EMOTIONS_COUNT = { pleased: 3, sad: 3, thinking: 3, praise: 5, greeting: 1 };

const getRandom = (packs: string[]) => {
  const index = Math.trunc(Math.random() * packs.length - 1);
  return packs[index];
};

class BotEmotions {
  private count = { ...AVAILABLE_EMOTIONS_COUNT };
  private stickerPack = getRandom(STICKER_PACKS);
  private phrasePack = getRandom(PHRASE_PACKS);

  private getSticker(stickers: string[]) {
    const sticker = stickers.find((name) => name.includes(this.stickerPack!))!;
    return { type: 'sticker', sticker: { id: `com.whitesharx.starfall.iap.${sticker}`, path: '' } } as const;
  }

  private willSendEmotion(percent: number) {
    return Math.random() * 100 < percent;
  }

  public chooseRandomPacks() {
    this.stickerPack = getRandom(STICKER_PACKS);
    this.phrasePack = getRandom(PHRASE_PACKS);
  }

  public sendReply(playerEmoji: ActPhrase, sendEmoji: (data: Emoji) => void) {
    const HELLO_ID = 1;
    const PRAISE_ID = 2;
    const THANK_ID = 3;
    if (playerEmoji.id === HELLO_ID && this.count.greeting) {
      this.count.greeting--;
      setTimeout(() => sendEmoji({ type: 'phrase', packId: this.phrasePack, id: 1 }), 2000);
    }
    if (playerEmoji.id === PRAISE_ID && ['phrase1', 'phrase2'].includes(this.phrasePack!)) {
      setTimeout(() => sendEmoji({ type: 'phrase', packId: this.phrasePack, id: THANK_ID }), 2000);
    }
  }

  public sendGreeting(moveNumber: number, sendEmoji: (data: Emoji) => void) {
    const canSendGreeting = this.count.greeting && moveNumber >= 2 && moveNumber <= 5;

    if (canSendGreeting && this.willSendEmotion(15)) {
      this.count.greeting--;
      setTimeout(() => sendEmoji({ type: 'phrase', packId: this.phrasePack, id: 1 }), 1000);
    }
  }

  public sendEmojiAfterBotMove = ({ winChance, isCaptured }: MoveData, sendEmoji: (data: Emoji) => void) => {
    if (winChance >= 0.1 && winChance <= 0.5 && isCaptured && this.count.pleased && this.willSendEmotion(20)) {
      this.count.pleased--;
      setTimeout(() => sendEmoji(this.getSticker(PLEASED_STICKERS)), 2000);
      return;
    }
    if (winChance >= -0.2 && winChance <= 0.2 && this.count.thinking && this.willSendEmotion(25)) {
      this.count.thinking--;
      setTimeout(() => sendEmoji(this.getSticker(THINKER_STICKERS)), 2000);
      return;
    }
    if (winChance >= -0.4 && winChance <= 0.4 && this.phrasePack === 'phrase3' && this.willSendEmotion(5)) {
      setTimeout(() => sendEmoji({ type: 'phrase', packId: this.phrasePack, id: 6 }), 2000); // have a plan;
      return;
    }
    if (this.phrasePack === 'phrase4' && this.willSendEmotion(5)) {
      setTimeout(() => sendEmoji({ type: 'phrase', packId: this.phrasePack, id: 4 }), 2000); // now you;
      return;
    }
  };

  public sendEmojiAfterPlayerMove = (
    { winChance, isCaptured, isBestMove }: MoveData,
    sendEmoji: (data: Emoji) => void
  ) => {
    if (isBestMove && this.count.praise && this.willSendEmotion(10)) {
      this.count.praise--;
      setTimeout(() => sendEmoji({ type: 'phrase', packId: this.phrasePack, id: 2 }), 2000);
      return;
    }
    if (winChance >= 0.5 && winChance <= 0.8 && isCaptured && this.count.sad && this.willSendEmotion(20)) {
      this.count.sad--;
      setTimeout(() => sendEmoji(this.getSticker(SAD_STICKERS)), 2000);
      return;
    }
    if (winChance >= -0.4 && winChance <= 0.4 && this.phrasePack === 'phrase3' && this.willSendEmotion(5)) {
      setTimeout(() => sendEmoji({ type: 'phrase', packId: this.phrasePack, id: 5 }), 2000); // well played;
      return;
    }
  };

  public resetCount() {
    this.count = { ...AVAILABLE_EMOTIONS_COUNT };
  }
}

export default new BotEmotions();
